import type { CarrierType } from "@/types/carrier";

/**
 * Mapping des IDs de livraison vers les types de transporteurs
 * Basé sur la configuration de l'ancien système (config.paris.php)
 *
 * IMPORTANT: Ce mapping est utilisé uniquement pour l'affichage visuel (badges, icônes).
 * Le nom réel du transporteur doit toujours être récupéré depuis data.livraison.libelle
 * dans la base de données pour garantir l'exactitude.
 */
const CARRIER_ID_MAP: Record<string, CarrierType> = {
  // COLISSIMO
  "1": "colissimo",
  "4": "colissimo",
  "8": "colissimo",
  "12": "colissimo",
  "16": "colissimo",
  "18": "colissimo",
  "2736": "colissimo",
  "2737": "colissimo",
  "2746": "colissimo", // Easy

  // DPD
  "10": "dpd",
  "13": "dpd",
  "2743": "dpd", // Easy

  // GLS
  "14": "gls",
  "15": "gls",
  "2742": "gls", // Easy

  // GPX
  "6": "gpx",
  "11": "gpx",
  "2649": "gpx",
  "2915": "gpx", // Easy

  // OCX
  "7": "ocx",
  "17": "ocx",
  "2741": "ocx", // OCX Africa

  // UPS
  "19": "ups",
  "2744": "ups", // Easy - UPS Multi
  "2745": "ups", // Easy

  // CHRONOPOST
  "2729": "chronopost",
  "2730": "chronopost",
  "2731": "chronopost",
  "2732": "chronopost",
  "2747": "chronopost", // Easy
  "2917": "chronopost", // Chrono Multi groupage
  "2918": "chronopost", // Chrono Multi groupage
  "2919": "chronopost",
  "2920": "chronopost",
  "2921": "chronopost",
  "2922": "chronopost",

  // GLS (compléments)
  "2931": "gls", // GLS Multi

  // COLISSIMO (compléments)
  "2924": "colissimo",
  "2925": "colissimo",
  "2923": "ups", // UPS Saver
  "2932": "ups", // UPS Standard (cf. config.paris.php + livraisons)

  // DHL
  "2733": "dhl",
  "2734": "dhl",
  "2735": "dhl",
  "2738": "dhl",
  "2739": "dhl",
  "2740": "dhl", // Esendeo - DF_EUROPE

  // FEDEX
  "2748": "fedex", // Easy - Fedex
  "2926": "fedex",
  "2927": "fedex",
  "2928": "fedex",
  "2929": "fedex",
  "2930": "fedex",

  // BOLLORE
  "2916": "bollore", // Easy - Bolloré
};

/**
 * Convertit un ID de livraison en type de transporteur
 * @param idLivraison - ID de la livraison depuis la base de données
 * @returns Le type de transporteur correspondant, ou 'client' pour les transporteurs acheteur
 */
export function mapCarrierIdToType(
  idLivraison: number | string | null | undefined,
): CarrierType {
  if (!idLivraison) return "client";

  const idStr = idLivraison.toString();
  return CARRIER_ID_MAP[idStr] || "client";
}
